export default __webpack_public_path__ + "static/ezycount-logo.1d9bb93e.svg";